<div class="access-denied-wrap flex flex-col items-center px-4">
    <img src="/assets/images/access-denied.svg" alt="Access denied" class="access-denied-illustration">

    <h2 class="orange-text font-bold text-2xl mt-2">Access denied</h2>
    <p class="violet-text font-medium text-sm mt-2 text-center">
        You don't have permission to view this page.<br>
        Please contact an admin if you need assistance.
    </p>
</div>